import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useState, useRef } from 'react';

export const VideoTestimonial = ({ 
  videoUrl, 
  title,
  subtitle,
  proofImages = [],
  index = 0
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const hasProofs = proofImages.length > 0;

  return (
    <motion.div 
      data-testid="video-testimonial"
      className="flex flex-col items-center"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      {/* Titre */}
      <h3 className="text-lg md:text-xl font-bold text-white mb-2 text-center">
        {title}
      </h3>
      {subtitle && (
        <p className="text-sm text-[#00A3FF] mb-4">{subtitle}</p>
      )}
      
      {/* Video container */}
      <div 
        className="relative w-[250px] aspect-[9/16] rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(0,163,255,0.1)] bg-black cursor-pointer group"
        onClick={handlePlay}
      >
        <video
          ref={videoRef}
          src={videoUrl}
          className="w-full h-full object-cover"
          playsInline
          loop
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        />
        
        {/* Play button overlay */}
        {!isPlaying && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-all">
            <div className="w-14 h-14 rounded-full bg-[#00A3FF] flex items-center justify-center shadow-[0_0_30px_rgba(0,163,255,0.5)]">
              <Play className="w-7 h-7 text-white ml-1" fill="white" />
            </div>
          </div>
        )}
      </div>

      {/* Proof images - displayed below video */}
      {hasProofs && (
        <div className="flex flex-row gap-3 mt-4">
          {proofImages.map((img, idx) => (
            <img 
              key={idx}
              src={img}
              alt={`Preuve ${idx + 1}`}
              className="w-32 h-auto rounded-lg border border-white/10 object-cover hover:scale-105 transition-transform cursor-pointer"
            />
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default VideoTestimonial;
